<template>
    <div>

        <trax-ui-form :id="id+'-password'" icons="1" :form="form" :action="action" :bus="bus" v-show="internal">

            <trax-ui-input type="password" icon="lock" :placeholder="lang.polaris.account.current_password"
                v-model="form.current_password" v-bind:error="errors.current_password" required="1">
            </trax-ui-input>

            <trax-ui-input type="password" icon="lock_outline" :placeholder="lang.polaris.account.new_password"
                v-model="form.new_password" v-bind:error="errors.new_password" required="1">
            </trax-ui-input>

            <trax-ui-input type="password" icon="lock_outline" :placeholder="lang.polaris.account.new_password_confirmation"
                v-model="form.new_password_confirmation" v-bind:error="errors.new_password_confirmation" required="1">
            </trax-ui-input>

        </trax-ui-form>

    </div>
</template>

<script>
    export default {
    
        data: function() {
            return {
                id: 'trax-account-user-edit',
                lang: lang,
                data: {
                    source: null
                },
                form: {
                    current_password: '',
                    new_password: '',
                    new_password_confirmation: ''
                },
                endpoint: app_url + "trax/api/front/users/me/password",
                errors: {},
                action: {
                    align: 'right',
                    label: lang.polaris.account.change_password
                },
                bus: this.$bus
            }
        },

        computed: {

            internal: function () {
                return this.data.source == 'internal';
            }
        },
        
        created: function() {
            var that = this;

            this.bus.$on(that.id+'-data', function(data) {
                that.selectData(data);
            });

            this.bus.$on(that.id+'-password-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-password-changed', function(data) {
                that.savePassword(data);
            });
        },

        methods: {

            savePassword(data) {
                var that = this;
                axios.post(this.endpoint, data)
                    .then(function (response) {
                        that.resetForm()
                        that.bus.$emit(that.id+'-toastr-success', that.lang.polaris.account.password_changed);
                    })
                    .catch(function (error) {
                        if (error.response.data.errors) {
                            that.processErrors(error.response.data.errors);
                        } else {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data);
                        }
                    });
            },

            resetForm() {
                this.form.current_password = '';
                this.form.new_password = '';
                this.form.new_password_confirmation = '';
            },

            selectData(data) {
                this.data = data;
                for (var index in this.form) {
                    this.form[index] = data[index];
                }
            },
            
            processErrors(errors) {
                for (var name in errors) {
                    var error = errors[name];
                    if (error instanceof Array) errors[name] = error[0];
                }
                this.errors = errors;
            }
        }
    }
</script>
